export default __webpack_public_path__ + "static/media/logoTmovPay.4cb1fd30.svg";